export default __webpack_public_path__ + "static/media/botty-checking.3ccec7fa.svg";